<div class="box">
  <div class="box-row header">
    <app-header-bar [backRoute]="'/partner-organizations'" [title]="title || 'organizations.title'" [autoTranslateTitle]="title === undefined"></app-header-bar>
  </div>
  <div class="box-row content mt-2">
    <div class="row w-100">
      <app-datatable [dataSource]="userSource" [columns]="columns" [identifier]="'users'" [customActions]="customActions" [customTableActions]="customTableActions"
        (newEvent)="new()" (showEvent)="edit($event.valueOf())">
        <app-empty-table [icon]="'person'" [emptyText]="'user.empty_text' | translate" [buttonText]="'user.createNew' | translate"
          (btnClick)="new()">
        </app-empty-table>
      </app-datatable>

      <app-error [error]="error"></app-error>

      <app-model-modal #EditModal (saveEvent)="onSave()">
        <app-partner-user-form #form (closeEvent)="onModalClose()" (loadingEvent)="onLoading($event.valueOf())"></app-partner-user-form>
      </app-model-modal>
    </div>
  </div>
</div>